import { styled } from '@tink/tink-link-core/src/styledTinkLink';

export const ProviderLogo = styled.img`
  width: ${({ theme }) => theme.sizes.xxlarge};
  height: ${({ theme }) => theme.sizes.xxlarge};
  border-radius: ${({ theme }) => theme.roundedCorners.huge};
`;

export const PlusSign = styled.div`
  margin-left: ${({ theme }) => theme.sizes.xsmall};
  margin-right: ${({ theme }) => theme.sizes.xsmall};
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.sizes.medium};
`;

export const LogoRow = styled.div`
  display: flex;
  & img {
    box-shadow: ${({ theme }) => theme.shadows.small};
  }
  & img:not(:first-child) {
    margin-left: -25px;
  }
`;

export const RoundedIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f8f9;
  border-radius: ${({ theme }) => theme.roundedCorners.huge};
  box-shadow: ${({ theme }) => theme.shadows.small};
  width: ${({ theme }) => theme.sizes.xxlarge};
  height: ${({ theme }) => theme.sizes.xxlarge};
`;
